export default __webpack_public_path__ + "static/media/ILUSTRACIONES_04.23a01d2c.png";